import React from 'react'
import CardWrapper from '../CardWrapper'

const TabPicture = ({ image, text, description, link,alt = "Picture", config, ...props }) => {

  if (text || description) {
    return (
      <CardWrapper text={text} description={description} link={link} config={config} {...props}>
        <div className='flex flex-col justify-center items-center gap-[10px] pt-v3-xxs px-v3-xxs pb-0 '>
          <img
            src={image}
            alt={alt}
            className="w-full h-[200px] rounded-v3-lg  bg-gray-300 object-cover"
          />
        </div>
      </CardWrapper>
    )
  }

 
  return (
    <img
      src={image}
      alt={alt}
      className="h-[200px] w-full rounded-v3-lg  bg-gray-300 object-cover"
      {...props}
    />
  )
}

export default TabPicture
